import { Grid, Tooltip, Typography } from "@mui/material"
import { ProgressWheel, StyledPaper } from "../commons"
import { displayNumber } from "../commons/utils"

export interface BorrowCapacityStatsType {
  title: string
  borrow: number
  borrowCap: number
}

const BorrowCapacityStats = (props: BorrowCapacityStatsType) => {
  const { title, borrow, borrowCap } = props
  const progressValue = !borrow || !borrowCap ? 0 : (borrow / borrowCap) * 100
  return (
    <Grid item sx={{ width: { xs: '100%', sm: '100%' } }}>
      <StyledPaper color='primary' sx={{
        padding: { xs: '0.5rem 1rem', sm: '1rem 1.5rem' },
        // backgroundColor: '#283D3E', 
        minWidth: { xs: '15rem', sm: '20rem' },
        maxWidth: { xs: '100%', sm: '100%' },
        width: '100%',
        minHeight: { xs: '5rem', sm: '6rem' },
        borderRadius: 1
      }}>
        <Grid container flexDirection={'row'} flexWrap={'nowrap'} alignItems={'center'} justifyContent={"space-between"}>
          <Grid item container flexDirection={'column'} gap={2}>
            <Tooltip title={"The maximum amount you can borrow based on your current collateral and health factor."}>
              <Typography variant="body6" color='text.secondary' sx={{
                textDecoration: 'underline dotted',
                textUnderlineOffset: 4,
                cursor: 'pointer'
              }}>
                {title}
              </Typography>
            </Tooltip>
            <Grid item>
              <Typography variant="body4" color='text.primary'>
                ${displayNumber(borrow, 2, 2)}
              </Typography>
              <Typography variant="body4" color='text.secondary'>
                /${displayNumber(borrowCap, 2, 2)}
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <ProgressWheel value={Math.min(progressValue, 100)} />
          </Grid>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default BorrowCapacityStats